<template>
    <div v-if="event.provider ? event.provider.includes('survey') : false">
        <div class="question-actions">
            <SurveyHistory
                v-if="event.modified_time"
                :id="event.id"
                :event="event"
                :patient="patient"
                :question="question">
            </SurveyHistory>
            <el-button class="edit-button" @click="showEdit = !showEdit">
                <EditSurveyIcon></EditSurveyIcon>
            </el-button>
        </div>
        <el-dialog :append-to-body="true"
            class="send-now-modal edit-question-modal"
            :visible.sync="showEdit"
            :close-on-click-modal="false"
            :before-close="closePopup">
            <span slot="title"> Edit answer </span>
            <div class="question-title">
                {{qNum + "."}} {{ question.title }} <span class="question-content">({{ question.question }})</span>
            </div>
            <div class="flex-cont">
                <div class="date inl">
                    {{ qDate }}
                </div>
                <div class="inl">
                    <el-radio-group v-model="updateResponse" @click.native="onRadioChange()">
                        <el-radio-button 
                            @click.native.prevent="clickItem(option.label)"
                            v-for="option in questionOptions" 
                            :key="option.value"
                            :label="option.label">
                                {{ option.description ?  option.description : option.label }}
                        </el-radio-button>
                    </el-radio-group>
                    <span v-if="(updateResponse == '' || updateResponse == null || updateResponse == undefined)" class="no-answer">
                        Not Answered
                    </span>
                </div>
            </div>
            <div class="footer">
                <div class="remove-response" v-if="showRmvResp">
                    <RemoveResponseIcon></RemoveResponseIcon>
                    <span @click="removeResponse()">Remove Response</span>
                </div>
                <div class="mandatory-quest" v-if="checkIfMandatory()"> 
                    <span>
                        * Mandatory
                    </span>
                </div>
                <el-button type="text" size="small" class="cancel-button" @click="closePopup()">
                    Cancel
                </el-button>
                <LoadingButton
                        type="primary"
                        size="small"
                        class="send-button"
                        :disabled="!enableSave"
                        @click="updateQuestion"
                        :loading="savingEdit">
                    Save
                </LoadingButton>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionEdit from './'
import Icons from '../analysis/response/icon'

export default {
    name: 'radio-select',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            questionOptions: this.getQuestionOptions(),
            enableSave: false,
            showRmvResp: !this.checkIfMandatory() && this.response,
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        closePopup() {
            this.showEdit = false
            this.enableSave = false
            this.updateResponse = this.getQuestionResponse()
            this.showRmvResp = !this.checkIfMandatory() && this.response
        },
        clickItem(e) {
            if(e === this.updateResponse && !this.checkIfMandatory()) this.updateResponse = null
            else this.updateResponse = e
        },
        removeResponse() {
            this.updateResponse = null
            this.showRmvResp = false
            this.enableSave = this.checkIfMandatory() ? false : true
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate()
            else
                update.push(this.getQuestionUpdate())
            console.log('Index - ',this.updateIndex)
            console.log(update)
            //return
            this.savingEdit = true
            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false,
                    this.enableSave = false,
                    this.showEdit = false,
                    this.updateResponse = this.getQuestionResponse(),
                    this.showRmvResp = !this.checkIfMandatory() && this.response
                })
        },
        getQuestionOptions() {
            switch (this.question.type) {
                case 'binary':
                    return [{
                        label: 'Yes',
                        value: 'Yes'
                    }, {
                        label: 'No',
                        value: 'No'
                    }]
                    break
                case 'radio':
                    return Array.from(Array(5)).map((_, index) => ({
                        label: index + 1,
                        value: index + 1
                    }))
                case 'scroller':
                    return  Object.entries(this.question.label).map(([key, value]) => ({
                        value: `${key}::${value}`,
                        label: String((parseInt(key) + 1)),
                        description: value ? value : String((parseInt(key) + 1))
                    }))
                case 'slider':
                    return Array.from(Array(this.question.max)).map((_, index) => {
                        const valueIndex = this.question.options[index]
                        return {
                            value: `${index}::${valueIndex && valueIndex.value ? valueIndex.value : ' '}`,
                            label: String((parseInt(index) + 1)),
                            description: valueIndex && valueIndex.description ? valueIndex.description : String((parseInt(index) + 1))
                        }
                    })
                default:
                    return []
            }
        },
        getQuestionResponse() {
            if(!this.oresponse)
                return ''
            switch (this.question.type) {
                case 'binary':
                    {
                        if(this.oresponse && Array.isArray(this.oresponse) && this.oresponse.length > 0)
                            return this.oresponse[0].value
                        else {
                            return this.oresponse[0]
                        }
                    }
                case 'radio': 
                    {
                        if(this.oresponse && Array.isArray(this.oresponse) && this.oresponse.length > 0)
                            return String(parseInt(this.oresponse[0].value) + 1)
                        else {
                            return this.oresponse + 1
                        }
                    }
                case 'scroller': {
                    if(this.oresponse && Array.isArray(this.oresponse) && this.oresponse.length > 0)
                        return String(parseInt(this.oresponse[0].value) + 1)
                    else {
                        return String(parseInt(Object.values(this.oresponse)[0]))
                    }
                }
                case 'slider': {
                    if(this.oresponse && Array.isArray(this.oresponse) && this.oresponse.length > 0)
                        return String(parseInt(this.oresponse[0].value) + 1)
                    else {
                        return String(parseInt(Object.values(this.oresponse)[0]))
                    }
                }
                default:
                    return null
            }
        },
        getOptionObject(selectedValue) {
            return JSON.parse(JSON.stringify(this.question.options.find(({value}) => value == selectedValue)))
        },
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }

            switch (this.question.type) {
                case 'binary':
                    update.answer = this.updateResponse ? [this.getOptionObject(this.updateResponse)] : null
                    break
                case 'radio':
                    update.answer = this.updateResponse ? [this.getOptionObject(this.updateResponse - 1)] : null
                    break
                case 'scroller':
                    update.answer = this.updateResponse ? [this.getOptionObject(this.updateResponse - 1)] : null
                    break
                case 'slider':
                    update.answer = this.updateResponse ? [this.getOptionObject(this.updateResponse - 1)] : null
                    break
            }

            return update
        },
        onRadioChange() {
            this.enableSave = true
            this.showRmvResp = !this.checkIfMandatory() && this.updateResponse !== null ? true : false
        },
    },

    components: {
        ...Icons
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';
div.el-radio-group {
    label.el-radio-button {
        margin: 0 5px;

        ::v-deep span.el-radio-button__inner {
            border-radius: 25px;
            background-color: #F8F8F8;
            border: 1px solid #EEEEEE;
            box-sizing: border-box;
            color: #666666;
            font-size: 12px;
            box-shadow: none;
        }

        ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            border-radius: 25px;
            background-color: #EDF8DF;
            border: 1px solid #709F34;
            box-sizing: border-box;
            color: #709F34;
            font-size: 12px;
            box-shadow: none;
        }

        &:focus:not(.is-focus):not(:active):not(.is-disabled) {
            box-shadow: none;
        }
    }
}
</style>
